// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"0ad29220","652":"63037e1f"}[chunkId] + ".chunk.css";
};